import React, { Component } from 'react';
import Advertorial from '@media/rui-advertorial';
import PropTypes from 'prop-types';

const AD_CONFIG_SITE = 'rca';
const AD_CONFIG_SIZE_HALF_PAGE = '300x600';
const AD_CONFIG_SIZE_MREC = '300x250';
const AD_PARAMS_SECT = 'homepage';

export default class NewsAd extends Component {
  static propTypes = {
    channel: PropTypes.string,
    state: PropTypes.string,
  };

  componentDidMount() {
    this.loadAds();
  }

  loadAds() {
    const { channel, state } = this.props;

    Advertorial.createAd({
      config: {
        site: AD_CONFIG_SITE,
        sz: AD_CONFIG_SIZE_HALF_PAGE,
      },
      params: {
        pos: 'medrec1',
        sect: AD_PARAMS_SECT,
        channel,
        state,
      },
      container: this.container1,
    });

    Advertorial.createAd({
      config: {
        site: AD_CONFIG_SITE,
        sz: AD_CONFIG_SIZE_MREC,
      },
      params: {
        pos: 'medrec2',
        sect: AD_PARAMS_SECT,
        channel,
        state,
      },
      container: this.container2,
    });

    Advertorial.refreshView();
  }

  render() {
    return (
      <div className="news-ad">
        <div
          id="ads-a"
          className="ad"
          ref={(ref) => {
            this.container1 = ref;
          }}
        />
        <div
          id="ads-b"
          className="ad"
          ref={(ref) => {
            this.container2 = ref;
          }}
        />
      </div>
    );
  }
}
